type Sub = () => void;

export function createStore<T>(value: T) {
  const subs = new Set<Sub>();
  return {
    subscribe: (cb: Sub) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    set: (newValue: T) => {
      value = newValue;
      for (const sub of subs) sub();
    },
    get: () => value,
  };
}
